export default __webpack_public_path__ + "static/media/correcttick.08c72a3a.svg";